var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 360,
    viewBox: "0 0 79.375 95.25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.05946 -5.0962)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5008 90.882v4.6178h70.492v-4.6178z",
    fill: "#15ac53"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-13.229 -.00025833)",
    d: "m23.756 29.156a31.675 31.089 0 0 0-2.5146 11.891 31.675 31.089 0 0 0 0.10904 1.496v48.513h63.132v-48.513a31.675 31.089 0 0 0 0.10904-1.496 31.675 31.089 0 0 0-31.675-31.089 31.675 31.089 0 0 0-14.33 3.3683 13.372 12.327 0 0 1 0.60461 3.6597 13.372 12.327 0 0 1-13.372 12.327 13.372 12.327 0 0 1-2.0629-0.15761z",
    fill: "#15ac53"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-13.229 -.00025833)",
    d: "m23.756 29.156a13.372 12.327 0 0 0 2.0629 0.15761 13.372 12.327 0 0 0 13.372-12.327 13.372 12.327 0 0 0-0.60461-3.6597 31.675 31.089 0 0 0-14.83 15.829z",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.a89c9eb4abb9114c37454601a8063c3a.svg";
export { ForwardRef as ReactComponent };